export const uploadToCloudinary = async (file: File): Promise<string> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET ?? '')

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
    { method: 'POST', body: formData }
  )

  if (!response.ok) {
    throw new Error('画像のアップロードに失敗しました')
  }

  const data = await response.json()

  if (!data.secure_url) {
    throw new Error('画像のアップロードに失敗しました')
  }

  return data.secure_url.replace('/upload/', '/upload/f_webp/')
}
